module.exports = __webpack_public_path__ + "static/set_filters-f10076350885e052cc7d7cd1b1a2b1ce.png";